export async function getAllUsers() {

    const response = await fetch('/api/users');
    return await response.json();
  }
  
  export async function createUser(data) {
    const response = await fetch(`/api/user`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data)
      })
    return await response.json();
  }

  export async function authenticateUser(username, password) {
    const response = await fetch(process.env.VUE_APP_ROOT_API + '/api/account/authenticate', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({username: username, password: password})
    })
    return await response.json();
  }

  export async function verifyRegistration(username) {
    const response = await fetch(process.env.VUE_APP_ROOT_API + '/api/account/verifyRegistration', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({username: username})
    })
    return await response.text();
  }

  export async function registerUser(username, password, validationCode) {
    const response = await fetch(process.env.VUE_APP_ROOT_API + '/api/account/register', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({username: username, password: password, validationCode: validationCode})
    })
    return await response.text();
  }

  export async function forgotpassword(username) {
    const response = await fetch(process.env.VUE_APP_ROOT_API + '/api/account/forgotpassword', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({username: username})
    })
    return await response.text();
  }

  export async function updatepassword(username, password, validationCode) {
    const response = await fetch(process.env.VUE_APP_ROOT_API + '/api/account/updatepassword', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({username: username, password: password, validationCode: validationCode})
    })
    return await response.text();
  }